import styled, {css} from 'styled-components';
import {NavLink} from 'react-router-dom';
import {device} from 'styled/device';

type TabProps = {
  selected?: boolean;
  disabled?: boolean;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TabsContainer = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  max-width: 330px;
  margin: 0 auto 40px;

  @media (max-width: ${device.mobileXL}) {
    box-shadow: 0 3px 0 rgba(0, 0, 0, 0.03);
  }
`;

const getTabStyles = (props: TabProps) => css`
  /* width: 100%; */
  width: 208px;
  height: 56px;
  cursor: ${props.disabled ? 'none' : 'pointer'};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  color: ${props.disabled ? '#B1B5C4' : '#152946'};
  transition: background 0.5s ease;
  border-bottom: 2.5px solid transparent;

  ${props.selected &&
  css`
    border-bottom: 2.5px solid #393abd;
  `}

  ${props.disabled &&
  css`
    pointer-events: none;
  `}
`;

export const TabItem = styled.div<TabProps>`
  ${props => getTabStyles(props)}
`;

export const NavLinkTab = styled(NavLink)<TabProps>`
  ${props => getTabStyles(props)}

  &.active {
    border-bottom: 2.5px solid #393abd;
  }
`;

export const ContainerChildren = styled.div`
  display: flex;
  justify-content: center;
`;
